import { render, staticRenderFns } from "./userTagCom.vue?vue&type=template&id=d8f0c582"
import script from "./userTagCom.vue?vue&type=script&lang=js"
export * from "./userTagCom.vue?vue&type=script&lang=js"
import style0 from "./userTagCom.vue?vue&type=style&index=0&id=d8f0c582&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/crm-admin-uat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8f0c582')) {
      api.createRecord('d8f0c582', component.options)
    } else {
      api.reload('d8f0c582', component.options)
    }
    module.hot.accept("./userTagCom.vue?vue&type=template&id=d8f0c582", function () {
      api.rerender('d8f0c582', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomerDrawerCom/rightCom/userTagCom.vue"
export default component.exports